import image1 from '../assets/lean-tools/light/5_whys.png';
import image2 from '../assets/lean-tools/light/5s.png';
import image3 from '../assets/lean-tools/light/a3_project_report.png';
import image4 from '../assets/lean-tools/light/brainstorming.png';
import image5 from '../assets/lean-tools/light/dmaic.png';
import image6 from '../assets/lean-tools/light/fishbone_diagram.png';
import image7 from '../assets/lean-tools/light/gemba_walk.png';
import image8 from '../assets/lean-tools/light/histogram.png';
import image9 from '../assets/lean-tools/light/impact_map.png';
import image10 from '../assets/lean-tools/light/kaizen_project.png';
import image11 from '../assets/lean-tools/light/leadership.png';
import image12 from '../assets/lean-tools/light/lean_overview_and_assessment.png';
import image13 from '../assets/lean-tools/light/mistake_proofing.png';
import image14 from '../assets/lean-tools/light/pareto_chart.png';
import image15 from '../assets/lean-tools/light/pdca.png';
import image16 from '../assets/lean-tools/light/run_chart.png';
import image17 from '../assets/lean-tools/light/scatter_plot.png';
import image18 from '../assets/lean-tools/light/stakeholder_analysis.png';
import image19 from '../assets/lean-tools/light/standard_work.png';
import image20 from '../assets/lean-tools/light/value_stream_mapping.png';
import image21 from '../assets/lean-tools/light/waste_walk.png';
import image22 from '../assets/leanfitt_pro.png';

const iconMappings = {
  '5 Whys Report': image1,
  '5S Report': image2,
  'A3 Project Report': image3,
  'Brainstorming Report': image4,
  'DMAIC Report': image5,
  'Fishbone Diagram Report': image6,
  'Gemba Walk Report': image7,
  'Histogram Report': image8,
  'Impact Map Report': image9,
  'Kaizen Project Report': image10,
  'Leadership Report': image11,
  'Lean Assessment Report': image12,
  'Mistake Proofing Report': image13,
  'Pareto Chart Report': image14,
  'PDCA Report': image15,
  'Run Chart Report': image16,
  'Scatter Plot Report': image17,
  'Stakeholder Analysis Report': image18,
  'Standard Work Report': image19,
  'Value Stream Mapping Report': image20,
  'Waste Walk Report': image21,
  'LeanFITT': image22,
};

export default iconMappings;
